module.exports = __webpack_public_path__ + "static/fonts/Oxanium-Medium.a4129138.ttf";